module.exports = __webpack_public_path__ + "static/media/11.87384f77.jpeg";